export default [
  {
    path: "/incomings",
    name: "incomings",
    component: () => import("../components/modules/incoming/IncomingList.vue"),
  },
];
